import v3 from "./content/mlperf-storage-v3";
import v2 from "./content/mlperf-storage-v2";
import v2en from "./content/mlperf-storage-v2-en";

const CHINESE_LOCALES = new Set(["zh-CN", "zh-TW"]);

export const posts = [
  {
    slug: "mlperf-storage-v3",
    date: "2026-09-01",
    publishAt: "2026-09-01T00:00:00+08:00",
    lang: "en",
    title:
      "NewFW Puts Solidigm's Gen5 & Gen4 Enterprise SSDs Through Every MLPerf Storage v3.0 Workload — the Only Single-Drive Run",
    excerpt:
      "Reference numbers for sizing AI storage on Solidigm's D7-PS1010 and D5-P5336 — fully public, fully reproducible. All 7 CLOSED results accepted.",
    cover: "/media/blog/mlperf-storage-v3/key-numbers.png",
    tags: ["MLPerf Storage v3.0", "Solidigm", "CWP"],
    markdown: v3,
  },
  {
    slug: "mlperf-storage-v2",
    date: "2026-03-18",
    lang: "zh-CN",
    title:
      "芯风威携手 Solidigm，在 MLPerf Storage v2.0 测试中斩获佳绩，尽显 AI 存储硬实力",
    excerpt:
      "Solidigm D7-PS1030 与 D5-P5336 在 MLPerf Storage v2.0 中取得卓越成绩。NewFW Technology CWP 助力系统级调优，释放 SSD 全部潜能。",
    cover: "/media/blog/mlperf-storage-v2/fig-09.jpg",
    tags: ["MLPerf Storage v2.0", "Solidigm", "CWP"],
    markdown: v2,
    translations: {
      en: {
        title:
          "NewFW Delivers Strong MLPerf Storage v2.0 Results, Showcasing AI Storage Performance",
        excerpt:
          "Solidigm D7-PS1030 and D5-P5336 posted strong MLPerf Storage v2.0 results. NewFW Technology CWP enabled system-level tuning to unlock the SSDs' full potential.",
        markdown: v2en,
      },
    },
  },
];

export function isPostPublished(post, now = Date.now()) {
  if (!post) return false;
  if (!post.publishAt) return true;
  return now >= Date.parse(post.publishAt);
}

export function localizePost(post, locale) {
  if (!post || CHINESE_LOCALES.has(locale) || post.lang === "en") {
    return post;
  }
  const english = post.translations?.en;
  return english ? { ...post, ...english, lang: "en" } : post;
}

export function postsForLocale(postsList, locale) {
  return postsList
    .filter((post) => isPostPublished(post))
    .map((post) => localizePost(post, locale));
}

export function getPost(slug, locale) {
  const post = posts.find((item) => item.slug === slug);
  if (!isPostPublished(post)) return undefined;
  return locale ? localizePost(post, locale) : post;
}

export function formatPostDate(date, locale) {
  const loc =
    locale === "zh-CN" ? "zh-CN" : locale === "zh-TW" ? "zh-Hant" : "en-US";
  return new Date(`${date}T00:00:00`).toLocaleDateString(loc, {
    year: "numeric",
    month: "short",
    day: "numeric",
  });
}
